// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__upbsm","label":"Labeled_label__13oPK","divider":"Labeled_divider__3Wc17"};